// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__Pb-Yu","balanceDisclaimer":"posDashboard_balanceDisclaimer__2L1w0"};